export default "__VITE_ASSET__BIRsEaYB__"